export const buttonStyle = {
  borderRadius: ".65rem",
  textTransform: "capitalize",
  fontWeight: 500,
  boxShadow: "none",
};

export const buttonStyleContained = {
  borderRadius: ".65rem",
  textTransform: "capitalize",
  fontWeight: 500,
  boxShadow: "none",
  backgroundColor: "#ECF2FF",
  color: "#0245A3",
  "&:hover": {
    backgroundColor: "#C4DDFF",
  },
};

export const buttonStyleOutlined = {
  borderRadius: ".65rem",
  textTransform: "capitalize",
  fontWeight: 500,
  borderColor: "#0245A3",
  color: "#0245A3",
  "&:hover": {},
};
